import { render } from "./TheCongSuatDen.vue?vue&type=template&id=07d089e0"
import script from "./TheCongSuatDen.vue?vue&type=script&lang=js"
export * from "./TheCongSuatDen.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__